/* eslint-disable import/prefer-default-export */

export const OPPORTUNITY_LIST_UPDATE = 'OPPORTUNITY_LIST_UPDATE';
export const OPPORTUNITY_UPDATE = 'OPPORTUNITY_UPDATE';
export const FILTER_UPDATE = 'FILTER_UPDATE';
export const UPDATE_STATUS = 'OPPORTUNITY_STATUS_UPDATE';
